// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__h2V1B","colBig":"styles_colBig__1xnk6","colSmall":"styles_colSmall__1n0pP","shopifyNameWrapper":"styles_shopifyNameWrapper__1XJsv"};